import { render, staticRenderFns } from "./productInfomation.vue?vue&type=template&id=1f6728ac&scoped=true&"
import script from "./productInfomation.vue?vue&type=script&lang=js&"
export * from "./productInfomation.vue?vue&type=script&lang=js&"
import style0 from "./productInfomation.vue?vue&type=style&index=0&id=1f6728ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6728ac",
  null
  
)

export default component.exports